import { Component, Input } from '@angular/core';
import { AggregateDocumentConfirmingFinancialRequest } from '../../../../../models/financial-movement/financial-movement';

@Component({
	selector: 'eif-financial-movements-registration-tab',
	templateUrl: './financial-movements-registration-tab.component.html',
	styleUrls: ['./financial-movements-registration-tab.component.scss'],
	standalone: false,
})
export class FinancialMovementsRegistrationTabComponent {
	@Input() aggregateDocument: AggregateDocumentConfirmingFinancialRequest;
}
